import React, { Component } from "react"
import { Configurations } from '../../Utils/Configurations';
// import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import axios from 'axios';
// import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import moment from 'moment';
import Geral from "../../Utils/Geral";
import update from 'immutability-helper';
import './Shipping-Dispatch.scss'

class ShippingDispatch extends Component {

    constructor(props) {
        super(props);

        this.Configurations = new Configurations();


        this.searchItem = this.searchItem.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.toggleFilters = this.toggleFilters.bind(this);
        this.addToFilter = this.addToFilter.bind(this);
        this.renderShippingItems = this.renderShippingItems.bind(this);
        this.handleChangePeso = this.handleChangePeso.bind(this);
        this.renderLocaisEntregaItens = this.renderLocaisEntregaItens.bind(this);
        this.handleChangePesoLocalEntrega = this.handleChangePesoLocalEntrega.bind(this);
        this.getShipping = this.getShipping.bind(this);
        this.removeItemFilter = this.removeItemFilter.bind(this);
        this.handleError = this.handleError.bind(this);
        this.definirPesosProdutos = this.definirPesosProdutos.bind(this);
        this.definirPesoRemessaLocaisEntrega = this.definirPesoRemessaLocaisEntrega.bind(this);
        this.gerarDeclaracao = this.gerarDeclaracao.bind(this);



        this.state = {
            products: [],
            productEditions: [],
            isLoadingProducts: true,
            infosClients: {},
            arrayFilter: [],
            openFilters: true,
            hasError: false,
            errorMessage: '',
            shippingItems: {},
            locaisEntregaItens: {},
            peso: '',
            isLoadingDefinirPesos: false,
            isLoadingGerarDeclaracao: false
        };
    }

    handleChange(e) {
        const { value, name } = e.target;
        this.setState({ [name]: value });
    }

    searchItem(e) {
        e.preventDefault();
        this.getShipping()
    }

    getShipping() {
        this.setState({ isLoadingShippingSearch: true })

        const _items = axios.get(this.Configurations.apiBasePath + `/logistica/remessas/${this.state.idRemessaBusca}/itens`);

        _items.then(response => {
            this.setState({
                shippingItems: response.data.resumoRemessaProduto,
                idRemessa: this.state.idRemessaBusca,
                locaisEntregaItens: response.data.resumoRemessaLocalEntrega
            })
        }).catch(err => {
            this.setState({ shippingItems: {}, idRemessa: null })
            this.handleError(err)
        }).finally(() =>
            this.setState({ isLoadingShippingSearch: false })
        )
    }

    toggleFilters() {
        this.setState({
            openFilters: !this.state.openFilters
        })
    }

    addToFilter(e) {
        e.preventDefault();
        let arrFilter = this.state.arrayFilter;
        const { selectedProduct, selectedEdition } = this.state;
        const duplicate = this.state.arrayFilter.findIndex(item => item.selectedProduct === selectedProduct && item.selectedEdition === selectedEdition);
        if (duplicate < 0) arrFilter.push({ selectedProduct, selectedEdition })
        this.setState({ arrayFilter: arrFilter })
    }


    removeItemFilter(i) {
        let _arrFilt = this.state.arrayFilter;
        _arrFilt.splice(i, 1)
        this.setState({ arrayFilter: _arrFilt })
    }

    renderShippingItems() {
        if (!this.state.shippingItems.listaProduto || this.state.shippingItems.listaProduto.length <= 0) return <div></div>

        return this.state.shippingItems.listaProduto.map((item, index) => {
            return <div className="col-2 px-1 py-2" key={index}>
                <div className="card">
                    <div className="card-body px-2 py-1">
                        <div className="row no-gutters">
                            <div className="col-12 text-center">
                                <p className="m-0 h3"><span className={`badge badge-${Geral.obtemTipoBadge(item.sigla).badgeColor}`}>{item.siglaProtheus}</span></p>
                                <p className="m-0 pt-2 font-weight-bold">{item.numEdicao}</p>
                                <p className="m-0"><small>{moment(item.dtEntrega).format("DD/MM/YYYY")}</small></p>
                                <p className="m-0">{item.quantidade} unidades</p>
                            </div>
                            <div className="offset-2 col-8 text-center py-1">
                                <input type="number" className='form-control text-center' name="peso" onChange={(e) => this.handleChangePeso(e, index)} value={this.state.shippingItems.listaProduto[index].pesoProduto} placeholder="peso (g)" />
                            </div>
                            {!!this.state.timestampPesoProduto && (
                                <div className="col-12 text-center itens-remessa">
                                    <p className="m-0">Atualizado em: {this.state.timestampPesoProduto}</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        })
    }

    handleChangePeso(e, index) {
        e.preventDefault();
        this.setState({
            shippingItems: update(this.state.shippingItems, { listaProduto: { [index]: { pesoProduto: { $set: e.target.value } } } })
        })
    }

    definirPesosProdutos() {
        this.setState({ isLoadingDefinirPesos: true })
        const _body = this.state.shippingItems.listaProduto.map(item => {
            return {
                idProduto: item.idProduto,
                peso: parseInt(item.pesoProduto, 10),
                idEdicao: item.idEdicao
            }
        })
        axios.post(this.Configurations.apiBasePath + `/logistica/remessas/${this.state.idRemessaBusca}/define-peso`, _body).then(response => {
            this.setState({
                locaisEntregaItens: response.data.resumoRemessaLocalEntrega,
                timestampPesoProduto: moment().format("HH:mm:ss")

            })

        }).catch(this.handleError).finally(() => this.setState({ isLoadingDefinirPesos: false }))
    }

    renderLocaisEntregaItens() {
        if (!this.state.locaisEntregaItens || this.state.locaisEntregaItens.length <= 0) return <div></div>

        return this.state.locaisEntregaItens.map((local, index) => {
            return <div className="col-4 px-1 py-1" key={index}>
                <div className="card card-locais-entrega">
                    <div className="card-body px-2 py-1">
                        <div className="row no-gutters">
                            <div className="col-12 text-center">
                                <p className="m-0 h3">{local.nomeLocal}</p>
                            </div>
                            <div className="col-12 text-center">
                                <div className="row d-flex justify-content-center">
                                    {local.listaProdutos.map((item, i) => {
                                        return <div className="col-3" key={i}>
                                            <p className="m-0 h5 py-2"><span className={`badge badge-${Geral.obtemTipoBadge(item.sigla).badgeColor}`}>{item.siglaProtheus}</span></p>
                                            <p className="m-0 pt-2 font-weight-bold">{item.numEdicao}</p>
                                            <p className="m-0"><small>{moment(item.dtEntrega).format("DD/MM/YY")}</small></p>
                                            <p className="m-0">{item.quantidade} un.</p>
                                        </div>
                                    })}
                                </div>
                            </div>
                            <div className="col-12 text-center py-2">
                                <label>Peso estimado total:</label>
                            </div>
                            <div className="col-12">
                                <div className="row d-flex justify-content-center">
                                    <div className="col-4 text-center">
                                        <input type="number" className='form-control' name="pesoDefinidoLocalEntrega" onChange={(e) => this.handleChangePesoLocalEntrega(e, index)} value={this.state.locaisEntregaItens[index].pesoDefinidoLocalEntrega} placeholder="peso (g)" />
                                    </div>
                                    {!!this.state.locaisEntregaItens[index].timestamp && (
                                        <div className="col-12 text-center itens-remessa py-1">
                                            <p className="m-0">Atualizado em: {this.state.locaisEntregaItens[index].timestamp}</p>
                                        </div>
                                    )}
                                    <div className="col-12 text-center py-3">
                                        {this.state.locaisEntregaItens[index].loading ? (
                                            <div className="spinner-border text-primary" role="status" />
                                        ) : (
                                            <button className="btn btn-primary" onClick={() => this.definirPesoRemessaLocaisEntrega(local.idLocalEntrega, this.state.locaisEntregaItens[index].pesoDefinidoLocalEntrega, index)}>definir peso</button>
                                        )}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        })
    }

    definirPesoRemessaLocaisEntrega(idLocalEntrega, peso, index) {
        const _body = {
            peso: peso
        }
        this.setState({ locaisEntregaItens: update(this.state.locaisEntregaItens, { [index]: { loading: { $set: true } } }) })

        axios.post(this.Configurations.apiBasePath + `/logistica/remessas/${this.state.idRemessaBusca}/local-entrega/${idLocalEntrega}/define-peso`, _body).then(response => {
            this.setState({
                locaisEntregaItens: update(this.state.locaisEntregaItens, { [index]: { timestamp: { $set: moment().format("HH:mm:ss") } } })
            })
        }).catch(this.handleError).finally(() => this.setState({ locaisEntregaItens: update(this.state.locaisEntregaItens, { [index]: { loading: { $set: false } } }) }))
    }

    handleChangePesoLocalEntrega(e, index) {
        e.preventDefault();
        this.setState({
            locaisEntregaItens: update(this.state.locaisEntregaItens, { [index]: { pesoDefinidoLocalEntrega: { $set: e.target.value } } })
        })
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response ? err.response.data.message : 'Erro inesperado.' })
    }

    gerarDeclaracao() {
        this.setState({ isLoadingGerarDeclaracao: true })
        axios.post(this.Configurations.apiBasePath + `/logistica/remessas/${this.state.idRemessaBusca}/declaracao`).then(response => {
            Geral.downloadPDF(response.data.declaracao, `declaracao`)
        }).catch(this.handleError).finally(() => this.setState({ isLoadingGerarDeclaracao: false }))
    }


    render() {
        return (
            <div className="row shipping-dispatch logistics">
                <div className="col-12">
                    <div className="row">
                        <div className="col-10">
                            <h2>Saída de remessa</h2>
                        </div>
                        <div className="col-2 text-right">
                            <button className="btn btn-outline-secondary" onClick={() =>
                                window.history.go(-1)}> voltar</button>
                        </div>
                    </div>
                </div>
                <div className="col-12 py-2">
                    <div className="card">
                        <div className={`card-body`} id="boxFilters">
                            {this.state.loading ? (
                                <div className="row no-gutters">
                                    <div className="col-12 text-center py-5">
                                        <div className="spinner-border text-primary" role="status" />
                                    </div>
                                </div>
                            ) : (

                                <div className="row">
                                    <div className="col-12 py-2">
                                        <div className="row align-items-end">
                                            <div className="col-4">
                                                <div className="form-group m-0">
                                                    <label htmlFor="ddlIdRemessa">Número da remessa</label>
                                                    <input id="ddlIdRemessa" name="idRemessaBusca" type="number" className="form-control" value={this.state.idRemessaBusca || ''} onChange={this.handleChange} />
                                                </div>
                                            </div>
                                            <div className="col-2 text-right">
                                                {this.state.isLoadingShippingSearch ? (
                                                    <div className="spinner-border text-primary" role="status" />
                                                ) : (
                                                    <button disabled={!this.state.idRemessaBusca} className="btn btn-primary" onClick={this.searchItem}>Buscar</button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 border my-2"></div>
                                    <div className="col-12 py-3">
                                        {!this.state.isLoadingShippingSearch && !!this.state.idRemessa && !!this.state.shippingItems.listaProduto && (
                                            <React.Fragment>
                                                <div className="row">
                                                    <div className="col-12 text-center">
                                                        <strong>Itens da remessa {this.state.idRemessa}</strong>
                                                    </div>
                                                </div>
                                                <div className="row d-flex justify-content-center">
                                                    {this.renderShippingItems()}
                                                </div>
                                                <div className="row py-3">

                                                    <div className="col-12 text-center">

                                                        {this.state.isLoadingDefinirPesos ? (
                                                            <div className="spinner-border text-primary" role="status" />
                                                        ) : (
                                                            <button className="btn btn-primary" onClick={this.definirPesosProdutos}>definir pesos dos itens</button>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12 border my-2"></div>
                                                </div>
                                                <div className="row d-flex align-items-stretch">
                                                    <div className="card-group">
                                                        {this.renderLocaisEntregaItens()}
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        )}
                                    </div>
                                    <div className="col-12 text-center py-2">
                                        {this.state.isLoadingGerarDeclaracao ? (
                                            <div className="spinner-border text-primary" role="status" />
                                        ) : (
                                            <button onClick={this.gerarDeclaracao} className="btn btn-success">gerar declaração</button>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>


            </div>
        )
    }
}

export default ShippingDispatch;